import { render, staticRenderFns } from "./webcam.vue?vue&type=template&id=67163b84&"
import script from "./webcam.vue?vue&type=script&lang=js&"
export * from "./webcam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67163b84')) {
      api.createRecord('67163b84', component.options)
    } else {
      api.reload('67163b84', component.options)
    }
    module.hot.accept("./webcam.vue?vue&type=template&id=67163b84&", function () {
      api.rerender('67163b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aCPJKSmnixPH/JS/webcam.vue"
export default component.exports